export const safeArray = (arr) => {
  return Array.isArray(arr) ? arr : [];
};
